// Quoting a post: where it is allowed, and the form under a post that
// Reply and Quote open.

// posts everyone may see, and your own followers-only posts
export const canQuote = ({ status, currentUser, quotingAvailable }) => {
  if (!quotingAvailable || !currentUser || !status) return false
  if (['public', 'unlisted', 'local'].includes(status.visibility)) return true
  return status.visibility === 'private' && status.user?.id === currentUser.id
}

// the form's mode after pressing Reply or Quote: the same one again closes
// it (null), the other one switches it
export const composerMode = (current, pressed) =>
  current === pressed ? null : pressed

// A quote in a post's text, for servers that know no quotes: "RE: <link>"
// at the end, often marked with the class quote-inline. Where the quote
// shows as a card, that goes: the marked part, or else a last line "RE:"
// with a link to the quoted post (and the line breaks before it).
// quoteUrls: the addresses the quoted post goes by, see quoteUrls.
export const withoutQuoteFallback = (html, quoteUrls) => {
  if (!html || !quoteUrls?.length) return html
  const body = new DOMParser().parseFromString(html, 'text/html').body
  const marked = body.querySelectorAll('.quote-inline')
  if (marked.length) {
    marked.forEach((el) => el.remove())
    return body.innerHTML
  }
  const link = [...body.querySelectorAll('a')].at(-1)
  if (!link || !quoteUrls.includes(link.getAttribute('href'))) return html
  const label = link.previousSibling
  const after = link.nextSibling
  if (label?.nodeType !== Node.TEXT_NODE || !/(^|\s)RE:\s*$/.test(label.data)) {
    return html
  }
  if (after && (after.nodeType !== Node.TEXT_NODE || after.data.trim())) {
    return html
  }
  const parent = link.parentNode
  after?.remove()
  link.remove()
  label.data = label.data.replace(/\s*RE:\s*$/, '')
  if (!label.data) label.remove()
  // the line breaks before it, then the paragraph if nothing is left
  while (parent.lastChild?.nodeName === 'BR') parent.lastChild.remove()
  if (
    parent !== body &&
    !parent.textContent.trim() &&
    !parent.querySelector('img')
  ) {
    parent.remove()
  }
  return body.innerHTML
}

// the addresses of a post's quote: its page, and its id (the fallback
// text of some servers links that)
export const quoteUrls = (status) =>
  [status.quote_url, status.quote?.url, status.quote?.external_url].filter(
    Boolean,
  )
